const messages = {
  username: 'Nombre de usuario',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña',
  forgotYourPassword: '¿Olvidaste tu contraseña?',
  login: 'Iniciar sesión',
  requiredField: 'Este campo es obligatorio.',
  resetPassword: 'Reiniciar contraseña',
  code: 'Código (revisa tu correo electrónico)',
  mandatoryPasswordResetRequired:
    'El restablecimiento de la contraseña se requiere para este usuario, de clic en ¿Olvidaste tu contraseña?',

  forms: {
    code: {
      required: 'El código es requerido',
    },
    confirmPassword: {
      match: 'Las contraseñas no coinciden',
    },
    password: {
      required: 'La contraseña es requerida',
      pattern:
        'La contraseña debe tener mínimo 8 caracteres y al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 caracter especial',
    },
    username: {
      required: 'El nombre de usuario es requerido',
    },
  },
  welcomeTitle: 'Ahorro energético',
  welcomeText:
    'Maximizamos la competitividad de su compañía, disminuyendo el impacto ambiental a través de la eficiencia energética.',
  learnMore: 'Conocer más',
  azimutName: 'Azimut Energía',
  azimutDescription: 'Gestión energética',
}

export default {
  messages,
}
